import React, { useEffect, useState } from "react";
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import { GET_GROUP_USER_FROM_UNO } from "../../../apiclient/apiEndpoints";
import apiclient from "../../../apiclient";
import { GROUP_LIMIT } from "../../../constant/constant";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../../NoDataFound";
import PlaceholderCard from "../../../components/skeleton/PlaceholderCard";
const { useUnoSelector } = UnoStoreHooks;
const { GroupUserCard, GridView } = UiComponents;

const UserTab = ({ UUID, querySearch = "", selectedFilter = [] }) => {
  const configData = useUnoSelector((state) => state.config);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  const UNO_URL = configData?.config?.UNO_URL;
  const limit = GROUP_LIMIT;
  const [page, setPage] = useState(1);
  const [userList, setUserList] = useState([]);
  const navigate = useNavigate();

  const fetchGroups = async (loadPage = page) => {
    try {
      const params = { page: loadPage, limit };
      if (querySearch) params.search = querySearch;
      if (selectedFilter?.length) {
        const roleIds = selectedFilter?.filter((e) => e.type == "role")?.map((e) => e.value) || [];
        const status = selectedFilter?.filter((e) => e.type == "status")?.map((e) => e.key) || [];
        if (roleIds?.length) params.roleIds = roleIds;
        if (status?.length) params.status = status;
      }

      const usersData = await apiclient.get(`${UNO_URL}${GET_GROUP_USER_FROM_UNO}/${UUID}`, { params });

      if (usersData?.length < limit) setHasMore(false);
      else setHasMore(true);

      const formattedData = usersData?.map((ele) => ({
        Name: ele.name,
        cardTypeUser: true,
        editButtonEnable: false,
        Image: ele.avatar,
        userDes: ele?.designation,
        userMail: ele?.email,
        isActive: true,
        user_id: ele.uid,
        // onClick: () => navigate(`/dashboard/${ele.uuid}`),
      }));
      setUserList((prev) => (loadPage === 1 ? formattedData : [...prev, ...formattedData]));
    } catch (error) {
      console.error("error in fetching from UNO", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    fetchGroups(1);
  }, [UUID, querySearch, selectedFilter]);

  const fetchMoreGroups = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchGroups(nextPage);
  };

  return (
    <>
      {loading ? (
        <GridView>
          <PlaceholderCard circle count={4} />
        </GridView>
      ) : userList.length > 0 ? (
        <div id="scrollableDiv" className="dashboardContent">
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            scrollThreshold={0.3}
            dataLength={userList.length}
            next={fetchMoreGroups}
            hasMore={hasMore}
            // loader={<PlaceholderCard circle count={4} />}
          >
            <div className="groups-tab">
              <GridView>
                {userList.map((user, index) => (
                  <GroupUserCard key={index} {...user} />
                ))}
                {hasMore && <PlaceholderCard circle={true} count={4} />}
              </GridView>
            </div>
          </InfiniteScroll>
        </div>
      ) : (
        <NoDataFound headText="No User Found" />
      )}
    </>
  );
};

export default UserTab;
